import axios from '../utils/axios';

export default {
  getPerfil() {
    return axios.get(`${process.env.REACT_APP_ROOT_API}exportador/perfil`, {
      data: {}
    });
  }
};
